<template><div><h1 id="refuse-steuertabelle" tabindex="-1"><a class="header-anchor" href="#refuse-steuertabelle"><span>Refusé Steuertabelle</span></a></h1>
<p>Refusé Steuertabelle — Definiert die Refusé Steuertabelle</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Diese Tabelle steuert die Personenstatus im Bezug auf Sperren.</p>
<p>Pfad: <code v-pre>Systemverwaltung → Tabellen → Refusé Steuertabelle</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Pos.</dt>
<dd>Positionsnummer zur Identifikation</dd>
<dt>Refusé-Kat.</dt>
<dd>Refusé-Kategorie</dd>
<dt>Anz.</dt>
<dd>Anzahl</dd>
<dt>Bereich</dt>
<dd>Bereich, Zusage, Spende oder Kauf</dd>
<dt>Filter</dt>
<dd>Adressfilter</dd>
<dt>Sperre</dt>
<dd>Art der Sperre, generell oder selektiv</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>Standardfunktionen</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
</div></template>


